/*
*
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties
* and other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the applicable
* third party licensors or the open source community as the case may be and nothing here transfers the rights to the third party
* and open source components, except as expressly permitted. Any unauthorized reproduction, storage, transmission in any
* form or by any means (including without limitation to electronic, mechanical, printing, photocopying, recording or 
* otherwise), or any distribution of this Program, or any portion of it, may result in severe civil and criminal penalties, and will be
* prosecuted to the maximum extent possible under the law.
* 
*/
import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
// Removed @angular/http import, not needed

@Injectable()
export class MdContentService {
  private actionColumnName: string = '';
  private confirmDialogTitle: string = '';
  private confirmDialogMessage: string = '';
  private cancelLabel: string = '';
  private totalRecordsLabel: string = '';
  private viewLabel: string = '';
  private editLabel: string = '';
  private deleteLabel: string = '';
  private filterLabel: string = '';

  getActionColumnName() {
    return this.actionColumnName;
  }

  setActionColumnName(name) {
    this.actionColumnName = name;
  }

  getConfirmDialogTitle() {
    return this.confirmDialogTitle;
  }

  setConfirmDialogTitle(title) {
    this.confirmDialogTitle = title;
  }

  getConfirmDialogMessage() {
    return this.confirmDialogMessage;
  }

  setConfirmDialogMessage(message) {
    this.confirmDialogMessage = message;
  }

  getCancelLabel() {
    return this.cancelLabel;
  }

  setCancelLabel(label) {
    this.cancelLabel = label;
  }

  getTotalRecordsLabel() {
    return this.totalRecordsLabel;
  }

  setTotalRecordsLabel(label) {
    this.totalRecordsLabel = label;
  }

  setViewLabel(label) {
    this.viewLabel = label;
  }

  getViewLabel() {
    return this.viewLabel;
  }

  setEditLabel(label) {
    this.editLabel = label;
  }

  getEditLabel() {
    return this.editLabel;
  }

  setDeleteLabel(label) {
    this.deleteLabel = label;
  }

  getDeleteLabel() {
    return this.deleteLabel;
  }

  setFilterLabel(label) {
    this.filterLabel = label;
  }

  getFilterLabel() {
    return this.filterLabel;
  }
}


